import * as React from 'react';
import { Link } from 'gatsby';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUserGroup,
  faHouse,
  faRankingStar,
  faBookOpen,
  faNewspaper,
  faStar,
  faPeopleGroup,
  faSpaghettiMonsterFlying,
  faBomb,
  faWandMagicSparkles,
  faUserPlus,
  faBook
} from '@fortawesome/free-solid-svg-icons';
import { useLocation } from '@reach/router';
import { Nav } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../../../state/Store';
import { ToggleMenu } from '../../../layout/actions/Layout.actions';

export const AFKMenu: React.FC = () => {
  const pathFragments = useLocation()
    .pathname.split('/')
    .filter((p) => p && p.trim().length > 0);
  const activeKey = pathFragments.length < 1 ? 'home' : pathFragments[0];

  const model = useSelector((state: RootState) => ({
    layout: state.layout
  }));

  const dispatch = useDispatch();

  const handleOnClick = () => {
    if (model.layout.isMenuVisible === true) {
      dispatch(ToggleMenu());
    }
  };

  return (
    <Nav className="ms-auto" activeKey={activeKey}>
      <Link to="/afk-journey/">
        <Nav.Link as="span" eventKey="home" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faHouse} width="18" /> <span>Home</span>
        </Nav.Link>
      </Link>
      <Link to="/afk-journey/characters">
        <Nav.Link as="span" eventKey="characters" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faUserGroup} width="18" />{' '}
          <span>Characters</span>
        </Nav.Link>
      </Link>
      <Link to="/afk-journey/tier-list">
        <Nav.Link as="span" eventKey="tier-list" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faRankingStar} width="18" />{' '}
          <span>Tier list</span>
        </Nav.Link>
      </Link>
      <Link to="/afk-journey/guides/wishlist-tips">
        <Nav.Link as="span" eventKey="wishlist" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faStar} width="18" /> <span>Wishlist</span>
        </Nav.Link>
      </Link>
      <Link to="/afk-journey/guides/exclusive-weapon-priority">
        <Nav.Link as="span" eventKey="wishlist" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faWandMagicSparkles} width="18" />{' '}
          <span>EX Weapon Priority</span>
        </Nav.Link>
      </Link>
      <hr />
      <Link to="/afk-journey/guides/afk-progression-teams">
        <Nav.Link as="span" eventKey="team" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faPeopleGroup} width="18" />{' '}
          <span>AFK Stages Teams</span>
        </Nav.Link>
      </Link>
      <Link to="/afk-journey/guides/arena-teams">
        <Nav.Link as="span" eventKey="team" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faBomb} width="18" /> <span>Arena Teams</span>
        </Nav.Link>
      </Link>
      <Link to="/afk-journey/guides/dream-realm">
        <Nav.Link as="span" eventKey="team" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faSpaghettiMonsterFlying} width="18" />{' '}
          <span>Dream Realm Teams</span>
        </Nav.Link>
      </Link>
      <hr />
      <Link to="/afk-journey/guides/beginner-guide">
        <Nav.Link as="span" eventKey="guide" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faBook} width="18" />{' '}
          <span>Beginner Guide</span>
        </Nav.Link>
      </Link>
      <hr />
      <Link to="/afk-journey/guides/">
        <Nav.Link as="span" eventKey="guides" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faBookOpen} width="18" /> <span>Guides</span>
        </Nav.Link>
      </Link>
      <Link to="/afk-journey/team-builder/">
        <Nav.Link as="span" eventKey="team-builder" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faUserPlus} width="18" />{' '}
          <span>Team Builder</span>
        </Nav.Link>
      </Link>
      <hr />
      <a href="https://blog.prydwen.gg/category/afk-journey/">
        <Nav.Link as="span" eventKey="blog">
          <FontAwesomeIcon icon={faNewspaper} width="18" /> <span>Blog</span>
        </Nav.Link>
      </a>
    </Nav>
  );
};
